import dayjs from 'dayjs'
import { useMemo } from 'react'

import { useMeQuery } from '@/src/features/auth/services/useMeQuery'
import { getDateWithoutTimezone } from '@/src/general/utils/getDateWithoutTimezone'

export const useLastBirthdayDate = () => {
  const { data: me } = useMeQuery()

  return useMemo(() => {
    let lastBirthdayDate = getDateWithoutTimezone(me?.birthdate)?.year(dayjs().year())
    if (lastBirthdayDate?.isAfter(dayjs())) {
      lastBirthdayDate = lastBirthdayDate.subtract(1, 'year')
    }

    return lastBirthdayDate
  }, [me?.birthdate])
}
